import React from "react";

const ResumeTitle = ({ icon, title }) => {
  return (
    <h1 className="text-lg text-mutedColor uppercase font-medium flex items-center gap-2 py-3 border-b-[1px] border-b-lineColor">
      <span className="text-designColor text-2xl">{icon}</span>
      {title}
    </h1>
  );
};

export default ResumeTitle;
